import { PostScreenComponent } from './../directive/post-screen/post-screen.component';
import { ProductProfileComponent } from './../product-profile/product-profile.component';
import { PostComponent } from './../post/post.component';
import { UserHomeComponent } from './user-home/user-home.component';
import { ReversePipe } from './user-home/reverse.pipe';
import { FormsModule } from '@angular/forms';
import { MomentModule } from 'angular2-moment';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from '../footer/footer.component';
import { RouterModule, Routes } from '@angular/router';
import { NgbModule, NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { UserProfileComponent } from '../user-profile/user-profile.component';
import { TrendTopicsComponent } from '../trend-topics/trend-topics.component';
import { FollowWidgetComponent } from '../follow-widget/follow-widget.component';
import { SponsoredTopicComponent } from '../sponsored-topic/sponsored-topic.component';
import { HashtagProfileComponent } from '../hashtag-profile/hashtag-profile.component';
import { BrandProfileComponent } from '../brand-profile/brand-profile.component';
import { UserComponent } from '../user/user.component';
import { PostProfileComponent } from './post-profile/post-profile.component';
import { UserlistItemComponent } from '../userlist-item/userlist-item.component';
import { ProfileSettingsComponent } from '../profile-settings/profile-settings.component';
import { AlertService } from '../_services/alert.service';
import { ScriptLoaderService } from '../_services/script-loader.service';
import { UserFollowersComponent } from '../user-followers/user-followers.component';
import { UserFollowingComponent } from '../user-following/user-following.component';
import { UserFavoritesComponent } from '../user-favorites/user-favorites.component';
import { SearchComponent } from './search/search.component';
import { ListItemComponent } from '../list-item/list-item.component';
import { CategoryComponent } from '../category/category.component';
import { SaveMessageComponent } from '../directive/save-message/save-message.component';
import { SanitizeHtmlPipe } from '../_pipe/sanitize-html.pipe';
import { LowerTextPipe } from '../lower-text.pipe';
import { PagesComponent } from './pages.component';
import { MessagesComponent } from '../messages/messages.component';
import { ProfileUpdateComponent } from '../profile-update/profile-update.component';
import { AccountSettingsComponent } from '../profile-update/account-settings/account-settings.component';
import { ChangePasswordComponent } from '../profile-update/change-password/change-password.component';
import { UserInterestedComponent } from '../profile-update/user-interested/user-interested.component';
import { CommentLoaderComponent } from '../directive/comment-loader/comment-loader.component';
import { CommentItemComponent } from '../directive/comment-item/comment-item.component';
import { LightboxModule } from 'angular2-lightbox';
import { MentionModule } from "../directive/mention/index";
import { ElasticSearchService } from "../_services/elastic-search.service";
import { TrendingComponent } from '../trending/trending.component';
import { WelcomePageComponent } from '../welcome-page/welcome-page.component';
import { PostTextComponent } from '../directive/post-text/post-text.component';
import { WelcomeGuard } from '../_guards/welcome.guard';
import { OwlModule } from 'ngx-owl-carousel';
import { WithLoaderModule } from '../directive/with-loader/with-loader.module';
import { PageNotFoundComponent } from './errors/page-not-found/page-not-found.component';
import { ImageUploadModule } from 'ng2-imageupload';
import { ImageCropComponent } from '../directive/image-crop/image-crop.component';
import { DirectMessageComponent } from '../directive/direct-message/direct-message.component';
import { WithDirectMessageDirective } from '../directive/direct-message/with-direct-message.directive';
import { ImportContactsComponent } from '../profile-update/import-contacts/import-contacts.component';
import { AboutUsComponent } from '../about-us/about-us.component';
import { GroupItemComponent } from '../list-item/group-item/group-item.component';
import { SilencedUserComponent } from '../profile-update/silenced-user/silenced-user.component';
import { ProductAdviceComponent } from '../product-advice/product-advice.component';
import { TimeAgoPipe } from '../_pipe/time-ago.pipe';
import { EmojiPickerDirective } from '../directive/emoji-picker/emoji-picker.directive';
import { EmojiPickerComponent } from '../directive/emoji-picker/emoji-picker.component';
import { RouterLinkPipe } from '../_pipe/router-link.pipe';
import { QueryLoaderComponent } from '../directive/loader/query-loader/query-loader.component';
import { ReplaceBadwordsPipe } from '../_pipe/replace-badwords.pipe';
import { ImageCropperModule } from 'ng2-img-cropper/src/imageCropperModule';
import { ReactiveFormsModule } from '@angular/forms';
import { UserService } from '../_services/user.service';
import { ImageToDataUrlService } from '../_services/image-to-data-url/image-to-data-url.service';
import { DeleteAccountComponent } from '../profile-update/delete-account/delete-account.component';
import { HtmlifyPipe } from '../_pipe/htmlify.pipe';
import { PhoneUpdateComponent } from '../profile-update/phone-update/phone-update.component';
import { Material } from '../_shared/material.module';
import { SearchbarComponent } from '../directive/searchbar/searchbar.component';
import { UsernameGuard } from '../_guards/username.guard';
import { NotificationsComponent } from './notifications/notifications.component';
import { PersonalInfoComponent } from '../profile-update/personal-info/personal-info.component';
import { LandingComponent } from './landing/landing.component';
import { LandingComponent2 } from './landing2/landing2.component';
import { LandingBrandComponent } from './landing-brand/landing-brand.component';
import { InfoNavBarComponent } from '../info-nav-bar/info-nav-bar.component';
import { PostService } from '../_services/post.service';
import { SeoService } from '../_services/seo.service';
import { CategoriesMenuComponent } from '../categories-menu/categories-menu.component';
import { ProfileWrapperComponent } from '../profile-update/profile-wrapper/profile-wrapper.component';
import { InviteBannersComponent } from '../invite-banners/invite-banners.component';
import { TourVideoComponent } from './tour-video/tour-video.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { PhoneTakeRequestComponent } from '../directive/phone-take-request/phone-take-request.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { LandingPage2Component } from './landing-page2/landing-page2.component';
import { CorporateComponent } from '../corporate/corporate.component';
import { TabsComponent } from '../corporate/tabs/tabs.component';
import { MembershipComponent } from '../corporate/membership/membership.component';
import { WorkComponent } from '../corporate/work/work.component';
import { SecurityDataComponent } from '../corporate/security-data/security-data.component';
import { FaqComponent } from '../corporate/faq/faq.component';
import { ConfidentialityComponent } from '../corporate/confidentiality/confidentiality.component';
import { ContactComponent } from '../corporate/contact/contact.component';
import { TextMaskModule } from 'angular2-text-mask';
import { PostItemModule } from '../post-item/post-item.module';
import { PostItemComponent } from '../post-item/post-item.component';
import { StoragePathPipe } from '../_pipe/storage-path.pipe';
import { PostBodyComponent } from '../post-item/post-body/post-body.component';
import { ReplyComponent } from '../post-item/reply/reply.component';
import { ReplyItemComponent } from '../post-item/reply-item/reply-item.component';
import { AngularFireDatabase } from 'angularfire2/database-deprecated';
import { SanitizeTextPipe } from '../_pipe/sanitize-text.pipe';
import { firstCharUpperPipe } from '../_pipe/uppercase.pipe';
import { MetaGuard } from 'ng2-meta';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { PostItemComponent3 } from '../post-item/post-item3.component';
import { PostItemComponent2 } from '../post-item/post-item2.component';
import { PostNativeAddComponent2 } from '../post-item/post-native-adds/post-native-adds.component';
import { PostNativeAddComponent } from '../post-item/post-native-add/post-native-add.component';
import { BrandsComponent } from '../brands/brands.component';
import { ProductsComponent } from '../products/products.component';
import { BlogHomeComponent } from '../blog-page/home/home.component';
import { BlogPostComponent } from '../blog-page/blogPost/blogPost.component';
import { BlogCategoryComponent } from '../blog-page/category/category.component';




const routes: Routes = [{
  path: '',
  component: PagesComponent,
  canActivate: [UsernameGuard],
  children: [{
    path: '',
    component: WelcomePageComponent,
    pathMatch: "full",
    canActivate: [WelcomeGuard, MetaGuard],
    data: {
      meta: {
        title: 'Müşteri Görüş Platformu | bigadvice.com',
        description: "Müşteri görüşlerinin şeffaf bir ortamda buluştuğu Türkiye'nin ilk ve tek bağımsız iletişim platformunda sen de markalarla ilgili deneyimlerini paylaşabilir, diğer kullanıcıların yorumlarını okuyabilirsin."
      }
    }

  }, {
    path: 'home',
    component: UserHomeComponent,
    canActivate: [MetaGuard],
    data: {
      meta: {
        title: 'Deneyimler Paylaştıkça Güzel! | bigadvice.com',
        description: "Müşteri görüşlerinin şeffaf bir ortamda buluştuğu Türkiye'nin ilk ve tek bağımsız iletişim platformunda sen de markalarla ilgili deneyimlerini paylaşabilir, diğer kullanıcıların yorumlarını okuyabilirsin."
      }
    }
  }, {
    path: 'product/:uniqueName',
    component: ProductProfileComponent
  }, {
    path: 'category/:category',
    component: CategoryComponent,
  }, {
    path: 'hashtag/:uniqueName',
    component: HashtagProfileComponent
  }, {
    path: 'brand/:uniqueName',
    component: BrandProfileComponent
  }, {
    path: 'user/:username',
    component: UserComponent
  }, {
    path: 'messages',
    component: MessagesComponent
  },

  {
    path: 'blog',
    children: [{
      path: 'home',
      component: BlogHomeComponent
    },
    {
      path: ':postKey',
      component: BlogPostComponent
    },
    {
      path:'category/:uniqueName',
      component:BlogCategoryComponent
    }

    ]

  },
  {
    path: 'profile-update',
    children: [{
      path: '',
      component: PersonalInfoComponent,
      pathMatch: "full"
    }, {
      path: 'phone-update',
      component: PhoneUpdateComponent,
    }, {
      path: 'account-settings',
      component: AccountSettingsComponent,
    }, {
      path: 'delete-account',
      component: DeleteAccountComponent
    }, {
      path: 'change-password',
      component: ChangePasswordComponent
    }, {
      path: 'silenced-user',
      component: SilencedUserComponent
    }, {
      path: 'user-interests',
      component: UserInterestedComponent
    }],
    component: ProfileUpdateComponent
  }, {
    path: 'notifications',
    component: NotificationsComponent
  }, {
    path: 'landing',
    component: LandingComponent
  },
  {
    path: 'landing2',
    component: LandingComponent2

  },
  {
    path: 'landing-brand/:uniqueName',
    component: LandingBrandComponent
  }, {
    path: 'landing-page2/:uniqueName',
    component: LandingPageComponent
  },
  {
    path: 'landing-page/:uniqueName',
    component: LandingPage2Component

  },
  {
    path: 'import-contact',
    component: ImportContactsComponent
  }, {
    path: 'post/:postKey',
    component: PostProfileComponent
  }, {
    path: 'followers',
    component: UserFollowersComponent
  }, {
    path: 'following',
    component: UserFollowingComponent
  }, {
    path: 'followingPosts',
    component: UserFavoritesComponent
  }, {
    path: 'search',
    component: SearchComponent
  }, {
    path: 'page-not-found',
    component: PageNotFoundComponent
  }, {
    path: 'about-us',
    component: AboutUsComponent
  }, {
    path: 'product-advice',
    component: ProductAdviceComponent
  }, {
    path: 'trend-topics',
    component: TrendTopicsComponent
  }, {
    path: 'trending',
    component: TrendingComponent
  }, {
    path: 'contact',
    component: ContactComponent
  }, {
    path: 'follow-mobile',
    component: FollowWidgetComponent
  }, {
    path: 'bigadvice-tour',
    component: TourVideoComponent
  },
  {
    path: 'brands',
    component: BrandsComponent

  },
  {
    path: 'products',
    component: ProductsComponent

  },

  {
    path: 'categories-menu',
    component: CategoriesMenuComponent
  }, {
    path: 'corporate',
    children: [{
      path: '',
      component: MembershipComponent,
      pathMatch: "full"
    }, {
      path: 'confidentiality',
      component: ConfidentialityComponent,
    }, {
      path: 'work',
      component: WorkComponent,
    }, {
      path: 'security-data',
      component: SecurityDataComponent
    }, {
      path: 'faq',
      component: FaqComponent
    }],
    component: CorporateComponent
  }]
}]

@NgModule({
  imports: [
    Material,
    CommonModule,
    NgbModule,
    MomentModule,
    ReactiveFormsModule,
    MentionModule,
    LightboxModule,
    AngularFireDatabaseModule,
    FormsModule,
    RouterModule.forChild(routes),
    OwlModule,
    WithLoaderModule,
    ImageUploadModule,
    // BrowserModule.withServerTransition({ appId: 'bigAdvice' }),
    ImageCropperModule,
    LazyLoadImageModule,

    TextMaskModule,
    PostItemModule,
    Material
  ],
  declarations: [
    firstCharUpperPipe,
    FooterComponent,
    FaqComponent,
    UserProfileComponent,
    TrendTopicsComponent,
    SecurityDataComponent,
    WorkComponent,
    PostScreenComponent,
    InviteBannersComponent,
    FollowWidgetComponent,
    SaveMessageComponent,
    ImportContactsComponent,
    SponsoredTopicComponent,
    UserHomeComponent,
    ProductAdviceComponent,
    SilencedUserComponent,
    TrendingComponent,
    EmojiPickerComponent,
    EmojiPickerDirective,
    ProductProfileComponent,
    HashtagProfileComponent,
    UserComponent,
    PostComponent,
    CommentItemComponent,
    UserlistItemComponent,
    TimeAgoPipe,
    ReversePipe,
    BrandProfileComponent,
    NotificationsComponent,
    PostProfileComponent,
    ProfileSettingsComponent,
    UserFollowersComponent,
    UserFollowingComponent,
    UserFavoritesComponent,
    SearchComponent,
    ListItemComponent,
    CategoryComponent,
    SanitizeHtmlPipe,
    SanitizeTextPipe,
    LowerTextPipe,
    CommentLoaderComponent,
    PostTextComponent,
    ImageCropComponent,
    PageNotFoundComponent,
    DirectMessageComponent,
    WithDirectMessageDirective,
    GroupItemComponent,
    RouterLinkPipe,
    QueryLoaderComponent,
    ReplaceBadwordsPipe,

    DeleteAccountComponent,
    HtmlifyPipe,
    PhoneUpdateComponent,
    SearchbarComponent,
    PersonalInfoComponent,
    LandingBrandComponent,
    LandingComponent,
    LandingComponent2,
    InfoNavBarComponent,
    PostNativeAddComponent,
    PostNativeAddComponent2,
    CategoriesMenuComponent,
    PostItemComponent3,
    BrandsComponent,

    ProductsComponent,
    PostItemComponent2,
    ProfileWrapperComponent,
    TourVideoComponent,
    InviteBannersComponent,
    PhoneTakeRequestComponent,
    LandingPageComponent,
    LandingPage2Component,
    CorporateComponent,
    TabsComponent,
    MembershipComponent,
    ConfidentialityComponent,
    ContactComponent,
    PostItemComponent,
    StoragePathPipe,
    PostBodyComponent,
    ReplyComponent, ReplyItemComponent
  ],
  entryComponents: [ImageCropComponent, SaveMessageComponent, PhoneTakeRequestComponent, EmojiPickerComponent, DirectMessageComponent],
  exports: [
    Material,
    firstCharUpperPipe,
    ProductProfileComponent,
    SearchbarComponent,
    LowerTextPipe,
    TextMaskModule,
    UserComponent,
    InfoNavBarComponent,
    ProfileWrapperComponent,
    StoragePathPipe,
    BrandProfileComponent, ReplaceBadwordsPipe, PostScreenComponent, ReversePipe, ImageCropperModule, ProfileSettingsComponent, PostTextComponent, ImageUploadModule,
    TimeAgoPipe, EmojiPickerDirective, ListItemComponent, SanitizeHtmlPipe, SanitizeTextPipe, RouterLinkPipe, CommentLoaderComponent, OwlModule, ImageCropComponent, CommentItemComponent, MentionModule, DirectMessageComponent, WithDirectMessageDirective],
  providers: [NgbDropdown, PostService, AlertService, ElasticSearchService, WelcomeGuard, ScriptLoaderService, AngularFireDatabase,
    UsernameGuard, UserService, ImageToDataUrlService, SeoService]
})
export class PagesModule { }



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/pages/pages.module.ts